export const LOCALES = {
    FRENCH: 'fr',
    SPANISH: 'es',
    ENGLISH: 'en',
    GERMAN: 'de',
    ITALIAN: 'it',
};

export const PLATFORMS = {
    FRANCE: 'fr',
    SPAIN: 'es',
    GREAT_BRITAIN: 'gb',
    GERMANY: 'de',
    ITALY: 'it',
};

export const PLATFORM_EXTENSIONS = {
    FR: '.fr',
    ES: '.es',
    GB: '.co.uk',
    DE: '.de',
    IT: '.it',
};
